/**
 * @file Manages styles for Paragraph atom.
 * @author kkumari
 */
import { css } from 'styled-components';
export default css(["outline:'solid';"]);